'use client';

import type { FC } from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { t } from '@/utils/lang';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

export interface OpenMapLinkProps {
    address?: string | null;
    tooltip?: string;
    className?: string;
}

const OpenMapLink: FC<OpenMapLinkProps> = ({
    address,
    tooltip = t('Mở trên Google Maps'),
    className,
}) => {
    const addr = address?.trim();

    if (!addr) return null;

    const href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        addr
    )}`;

    return (
        <Tooltip title={tooltip}>
            <IconButton
                size={'small'}
                component='a'
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                className={className}
                aria-label={tooltip}
                sx={{
                    fontSize: '15px !important',
                }}
            >
                <OpenInNewIcon fontSize='inherit' />
            </IconButton>
        </Tooltip>
    );
};

export default OpenMapLink;
